// FoodTypeMark — part of the product option modal (ProductOptionView).

import { dietKind } from '@core/utils/diet';

// Diet marker. `value` is the item's food-type name or slug: "veg…" renders the
// green dot, "NA" a grey dash, any other value the red triangle, and a blank
// value nothing.
const COLORS = { veg: '#1f9d55', nonveg: '#c0202e', na: '#8a8a8a' };

export default function FoodTypeMark({ value }) {
  const kind = dietKind(value);
  if (!kind) return <span className="po-nv po-nv-none" aria-hidden="true" />;
  const color = COLORS[kind];
  return (
    <span className={`po-nv is-${kind}`} aria-hidden="true">
      <svg viewBox="0 0 20 20" width="16" height="16">
        <rect
          x="1"
          y="1"
          width="18"
          height="18"
          rx="3"
          fill="none"
          stroke={color}
          strokeWidth="1.6"
        />
        {kind === 'veg' ? <circle cx="10" cy="10" r="4.2" fill={color} /> : null}
        {kind === 'nonveg' ? <polygon points="10,5.5 14.5,13.5 5.5,13.5" fill={color} /> : null}
        {kind === 'na' ? <rect x="5.5" y="9" width="9" height="2" rx="1" fill={color} /> : null}
      </svg>
    </span>
  );
}
